import React from 'react';
import { Container, Button, Dropdown } from 'semantic-ui-react';
import HeaderBG from '../components/HeaderBG';
import ParcelsImport from '../components/Parcels/ParcelsImport';
import SectionTitle from '../components/SectionTitle';
import DefaultLayout from '../layouts/DefaultLayout';

export default props => {
  return (
    <DefaultLayout
      currentPath={props.match.path}
      globalActions={
        <>
          <Dropdown text="Import" as={Button} primary compact>
            <Dropdown.Menu>
              {/* <Dropdown.Item
                text="From ShipHero"
                onClick={() => dispatch(toggleSHImport())}
              /> */}
              <Dropdown.Item text="CSV File" disabled />
            </Dropdown.Menu>
          </Dropdown>
        </>
      }
    >
      <HeaderBG />
      <Container>
        <SectionTitle>Parcels</SectionTitle>
        <ParcelsImport props={props} />
      </Container>
    </DefaultLayout>
  );
};